/**
 * The collection view's region filter, wired to the design mock's behavior:
 * one chip per region present among the registry claims (All first), and the
 * mock's two count-line formats in both languages. The chip vocabulary is the
 * port's display vocabulary (REGION_DISPLAY in main.ts) - Latin genus stems,
 * kept as taxonomy - so the region name passes through the copy unchanged.
 */

import { tr, type Lang } from "./i18n";

export const CONNECTOME_SIZE = "169,078";

/** ["all", then each region once, in first-seen order] - the chips to render. */
export function chipsFor(regions: readonly string[]): string[] {
  return ["all", ...new Set(regions)];
}

/** The count line under the filter row, in the design mock's words. */
export function countLine(lang: Lang, region: string, shown: number, hatched: number): string {
  const numbers = {
    shown: String(shown),
    region,
    hatched: String(hatched),
    total: CONNECTOME_SIZE,
  };

  if (region === "all") return tr(lang, "col.countAll", numbers);

  return tr(lang, "col.countRegion", numbers);
}
